import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Receipt from "@/pages/Receipt";
import Proposal from "@/pages/Proposal";
import Plans from "@/pages/Plans";
import Settings from "@/pages/Settings";
import InstallPrompt from "@/components/InstallPrompt";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/r/:token" element={<Receipt />} />
          <Route path="/proposta" element={<Proposal />} />
          <Route
            path="/planos"
            element={
              <ProtectedRoute allowExpired>
                <Plans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            className: "!bg-slate-900 !border-slate-700 !text-slate-100",
          }}
        />
        <InstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
